import BasicLoadable from "../../Loadable/BasicLoadable";

export const LoadableCancelOrderModalContainer = BasicLoadable({
  loader: () => import("./CancelOrderModalContainer"),
  loading: null,
});
